import React, { Component, ReactNode } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import AnalyticsUtil from '../../../analytics/AnalyticsUtil';
import SearchAnalytics from '../../../analytics/SearchAnalytics';
import {
	PRESEARCH_UI_SORT_ORDERS,
	SEARCH_CCD_CCH_SAMCAP_CGEN,
} from '../../../containers/SearchResultsPage/SearchConstants';
import SearchUtils from '../../../utils/SearchUtils';
import SearchDropdownSparkTemplates from '../SearchDropdownSparkTemplates/SearchDropdownSparkTemplates';

type Props = {
	searchHostContext: HostContext;
	logger: Logger;
	searchQuery: string;
	searchConfig: Record<string, any>;
} & PropsFromRedux;
class SearchDropdownPopularTemplates extends Component<Props> {
	render(): ReactNode {
		const templateData = this.getPopularTemplates();
		const results = templateData?.searchResults?.resultItems;
		const sapCode = templateData?.sapCode;
		const cgenMap = new Map(
			Object.entries({
				[SEARCH_CCD_CCH_SAMCAP_CGEN.cchClient]: {
					click: SEARCH_CCD_CCH_SAMCAP_CGEN.cchExpressCgenForPreSearchAXtemplates,
				},
				[SEARCH_CCD_CCH_SAMCAP_CGEN.ccdHost]: {
					click: SEARCH_CCD_CCH_SAMCAP_CGEN.ccdExpressCgenForPreSearchAXtemplates,
				},
			}),
		);
		if (window.navigator.onLine) {
			return (
				<SearchDropdownSparkTemplates
					resultItems={results}
					logger={this.props.logger}
					searchHostContext={this.props.searchHostContext}
					searchQuery={this.props.searchQuery}
					titleKey='app.search.popular.express.templates.title'
					viewAllLocation='Popular Adobe Spark templates'
					appId={sapCode}
					showRuler
					cgenMap={cgenMap}
					viewAllUrl={this.getPopularTemplatesViewAllUrl()}
					analyticCallbacks={{
						render: (data, analytics) => this.popularTemplateRenderAnalytics(data, analytics),
						templateClick: (data, analytics, index) =>
							this.popularTemplateClickAnalytics(data, analytics, index),
						carouselScroll: (e, analytics) => this.popularTemplateCarouselScroll(e, analytics),
						viewAll: (analytics) => this.popularTemplateViewAll(analytics),
					}}
				/>
			);
		}
		return null;
	}

	popularTemplateViewAll(analytics: SearchAnalytics) {
		analytics.postSeeAll('popularExpressTemplates');
	}
	popularTemplateRenderAnalytics(data: Array<ResultItem>, analytics: SearchAnalytics) {
		analytics.postPreSearchItemAction({
			recommendationType: 'popularExpressTemplates',
			eventType: 'render',
			uiSortOrder: PRESEARCH_UI_SORT_ORDERS.popularExpressTemplates,
			data,
		});
	}

	popularTemplateClickAnalytics(data: ResultItem, analytics: SearchAnalytics, index: number) {
		const url = data.attributes.openUrl || '';
		const appendedUrl = AnalyticsUtil.appendUrlWithAnalytics(url);
		analytics.postPreSearchItemAction({
			recommendationType: 'popularExpressTemplates',
			eventType: 'click',
			eventIndex: index,
			uiSortOrder: PRESEARCH_UI_SORT_ORDERS.popularExpressTemplates,
			data: [Object.assign({}, data, { actionUrl: appendedUrl })],
		});
	}

	popularTemplateCarouselScroll(e, analytics: SearchAnalytics) {
		analytics.postPreSearchCarouselScroll(e, 'popularExpressTemplates');
	}
	getPopularTemplatesViewAllUrl() {
		let viewAllUrl;
		const { ui } = this.props.searchConfig;
		if (ui && ui.links) {
			const envLinks: Record<string, any> =
				this.props.searchConfig.ui.links[this.props.searchHostContext.environment];
			if (envLinks?.viewAll?.projectx) {
				viewAllUrl = envLinks && envLinks.viewAll && envLinks.viewAll.projectx ? envLinks.viewAll.projectx : '';
			} else {
				viewAllUrl = envLinks && envLinks.viewAll && envLinks.viewAll.spark ? envLinks.viewAll.spark : '';
			}
			viewAllUrl = viewAllUrl.replace('{query}', this.props.searchQuery.split(' ').join('+'));
			if (!viewAllUrl) {
				return;
			}
			try {
				const tempViewAllUrl = new URL(viewAllUrl);
				tempViewAllUrl.searchParams.delete('key');
				const {
					hostInfo: { surface, client },
				} = this.props.searchHostContext;
				if (surface === SEARCH_CCD_CCH_SAMCAP_CGEN.ccdHost) {
					tempViewAllUrl.searchParams.set(
						'trackingid',
						SEARCH_CCD_CCH_SAMCAP_CGEN.ccdExpressCgenForPreSearchAXtemplatesViewAll,
					);
				} else if (client === SEARCH_CCD_CCH_SAMCAP_CGEN.cchClient) {
					tempViewAllUrl.searchParams.set(
						'promoid',
						SEARCH_CCD_CCH_SAMCAP_CGEN.cchExpressCgenForPreSearchAXtemplatesViewAll,
					);
				}
				viewAllUrl = tempViewAllUrl.toString();
			} catch (e) {
				this.props.logger.error(
					'CCExpress Templates',
					'Incorrect CCExpress Templates view all link',
					viewAllUrl,
				);
			}
		}
		return viewAllUrl;
	}

	getPopularTemplates() {
		return this.props.presearchResultsPayload?.popularExpressTemplates;
	}
}
const mapDispatchToProps = {};
const mapStateToProps = ({ search }: RootState) => ({
	presearchResultsPayload: search.presearchResultsPayload,
});
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SearchDropdownPopularTemplates);
